'use client'
import * as React from 'react'
import { useRouter } from 'next/navigation'

export default function NotFoundPage() {
  const router = useRouter()

  React.useEffect(() => {
    const originalPath = window.location.pathname
    // This is a workaround to redirect to the 404 page from the web app
    router.replace(`/b/404?original404Url=${originalPath}`)
  }, [router])

  return null
}
